angular.module('qkr').controller('LoyaltyCardActivateModalController', ($scope, $rootScope, $uibModalInstance,
                                                                        loyaltyCardService, loyaltyCard, utils,
                                                                        gettextCatalog) => {
    $scope.saving = false;

    $scope.init = function() {
        if (new Date(loyaltyCard.expiryDate).getFullYear() < 2999) {
            $scope.expiryDate = new Date(loyaltyCard.expiryDate);
            $scope.fixedExpiryDate = true;
        } else {
            $scope.expiryDate = new Date();
            $scope.expiryDate.setDate($scope.expiryDate.getDate() + 1);
            $scope.fixedExpiryDate = false;
        }
    };

    const validate = function() {
        $scope.errors = null;
        const errors = {};
        let valid = true;

        if ($scope.fixedExpiryDate) {
            if (utils.hasNoValue($scope.expiryDate)) {
                errors.expiryDate = gettextCatalog('Please enter an expiry date');
                valid = false;
            } else if ($scope.expiryDate <= new Date()) {
                errors.expiryDate = gettextCatalog('Expiry dates must be after today');
                valid = false;
            }
        }

        $scope.errors = errors;
        return valid;
    };

    $scope.activate = function() {
        if (!$scope.fixedExpiryDate) {
            $scope.expiryDate = new Date(3000, 0, 0, 0, 0, 0, 0);
        }

        if (!validate()) {
            return;
        }

        // Moving it to a second before midnight
        $scope.expiryDate.setSeconds(59);
        $scope.expiryDate.setMinutes(59);
        $scope.expiryDate.setHours(23);

        $scope.saving = true;
        loyaltyCardService.activateLoyaltyCard(loyaltyCard.id, $scope.expiryDate.getTime()).then((promise) => {
            $scope.saving = false;
            $uibModalInstance.close(promise);
        });
    };

    $scope.cancel = function() {
        $uibModalInstance.close('cancel');
    };

    $scope.dateOptions = {
        startingDay: $rootScope.merchantInfo.contactDetails.country.weekStartingDay,
        showWeeks: false
    };

    $scope.init();
});



// WEBPACK FOOTER //
// ./src/loyalty/controllers/loyaltyCardActivate.modal.controller.js